import {
  ErrorsFields,
  FormState,
  OptInOptions,
} from '@/core/interfaces/common';

import { CustomContactFields } from '@/features/NewForm/TakeActionFormContainerRedux/CustomContactFields';

import { hasAnyError } from '@/utils/helpers';

import {
  GeneralErrorMessage,
  SendButton,
  SubmitSection,
} from '@/themes/globalStyles';

import { ContactFieldsContainer } from '../ContactFieldsContainer';
import { OptCheckboxes } from '../OptCheckboxesSecunda';

interface SignupFormContainerProps {
  backgroundColor: string;
  buttonColor: string;
  submitButtonText: string;
  error: ErrorsFields;
  formState: FormState;
  isPending: boolean;
  optIn: OptInOptions;
  organizationName: string;
  textColor: string;
  setError: React.Dispatch<React.SetStateAction<ErrorsFields>>;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
}

export const SignupFormContainerRedux = ({
  backgroundColor,
  buttonColor,
  isPending,
  error,
  formState,
  optIn,
  organizationName,
  setError,
  setFormState,
  textColor,
  submitButtonText,
}: SignupFormContainerProps) => {
  const handleOptChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      checked,
    } = event.target;

    setFormState(prevValues => ({
      ...prevValues,
      [name]: checked,
    }));
  };

  return (
    <>
      <ContactFieldsContainer
        backgroundColor={backgroundColor}
        error={error}
        formState={formState}
        setError={setError}
        setFormState={setFormState}
        textColor={textColor}
        CustomContactFieldsComponent={CustomContactFields}
      />
      <SubmitSection>
        <SendButton
          backgroundcolor={buttonColor}
          className="muster-button"
          disabled={isPending}
          textcolor={textColor}
          type="submit"
          value={submitButtonText}
        />
        {hasAnyError(error) && (
          <GeneralErrorMessage>Please see errors above</GeneralErrorMessage>
        )}
      </SubmitSection>
      <OptCheckboxes
        isOptInEmail={formState.isOptInEmail}
        isOptInText={formState.isOptInText}
        backgroundColor={buttonColor}
        handleOptChange={handleOptChange}
        optIn={optIn}
        organizationName={organizationName}
      />
    </>
  );
};
